export const PROD_URL = "https://www.movimemo.com/api";
